import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Button,
  Box,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import ChecklistIcon from '@mui/icons-material/Checklist';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

function NavBarUser() {
  const storedUserName = localStorage.getItem('nombreUsuario');
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [anchorEl, setAnchorEl] = useState(null);

  const handleCerrar = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/');
    window.location.reload();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const links = [
    { label: 'selección', href: '/user/Seleccion', icon: <RestaurantMenuIcon fontSize="small" /> },
    { label: 'mi pedido semanal', href: '/user/mipedidosemanal', icon: <ChecklistIcon fontSize="small" /> },
  ];

  return (
    <AppBar
      position="static"
      sx={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        boxShadow: '0 10px 30px rgba(102, 126, 234, 0.2)',
        borderBottom: 'none'
      }}
    >
      <Toolbar className="flex justify-between items-center px-2 sm:px-6" sx={{ minHeight: { xs: '60px', sm: '70px' } }}>
        {/* Logo / Título + Menú hamburguesa */}
        <div className="flex items-center gap-3">
          {isMobile ? (
            <>
              <IconButton
                onClick={handleMenuOpen}
                sx={{
                  color: 'white',
                  transition: 'all 0.3s ease',
                  '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
                }}
                size="small"
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="body1" className="text-white font-bold text-sm">
                Mi Menú
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" className="text-white font-bold mr-6">
                🍽️ Panel de Usuario
              </Typography>
              <Box className="flex gap-1">
                {links.map((link) => (
                  <Button
                    key={link.href}
                    onClick={() => navigate(link.href)}
                    sx={{
                      minWidth: 'auto',
                      px: 3,
                      py: 1,
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      textTransform: 'capitalize',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        transform: 'translateY(-2px)',
                      }
                    }}
                    className="flex items-center gap-2"
                  >
                    {link.icon}
                    <span>{link.label.charAt(0).toUpperCase() + link.label.slice(1)}</span>
                  </Button>
                ))}
              </Box>
            </>
          )}
        </div>

        {/* Usuario + Cerrar sesión */}
        <div className="flex items-center gap-2 sm:gap-3 text-white">
          <div className="flex items-center gap-2 bg-white/15 px-3 py-1.5 rounded-lg">
            <PersonIcon fontSize="small" />
            <span className="hidden sm:inline font-semibold max-w-[150px] truncate text-sm">{storedUserName}</span>
          </div>
          <Button
            onClick={handleCerrar}
            size="small"
            sx={{
              backgroundColor: 'rgba(239, 68, 68, 0.9)',
              color: 'white',
              textTransform: 'capitalize',
              fontWeight: 600,
              padding: '6px 16px',
              borderRadius: '8px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(239, 68, 68, 1)',
                transform: 'scale(1.05)',
                boxShadow: '0 4px 12px rgba(239, 68, 68, 0.4)'
              }
            }}
            className="flex items-center gap-1"
          >
            <CloseIcon fontSize="small" />
            <span className="hidden sm:inline">Cerrar</span>
          </Button>
        </div>
      </Toolbar>

      {/* Menú hamburguesa para mobile */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            width: '100%',
            maxWidth: '100vw',
            boxShadow: '0 10px 30px rgba(102, 126, 234, 0.2)',
          },
        }}
      >
        <Box className="flex justify-end pr-4 pt-2">
          <IconButton
            onClick={handleMenuClose}
            sx={{
              color: 'white',
              transition: 'all 0.3s ease',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {links.map((link) => (
          <MenuItem
            key={link.href}
            onClick={() => {
              handleMenuClose();
              navigate(link.href);
            }}
            sx={{
              color: 'white',
              margin: '4px 8px',
              borderRadius: '8px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <div className="flex items-center gap-2 w-full font-semibold">
              {link.icon}
              <span className="text-[clamp(13px,2.5vw,16px)]">
                {link.label.charAt(0).toUpperCase() + link.label.slice(1)}
              </span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </AppBar>
  );
}

export default NavBarUser;
